import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Shield } from "lucide-react";
import { companyInfo, navigation } from "../data";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative border-t border-[#3d1b1c] bg-[#4c2223] text-gray-200 overflow-hidden">
      {/* Upper Footer */}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=320,quality=90,format=auto/assets/b6ab12dc-9087-41bb-8b7f-45b54510818a/screenshot-2026-06-08-at-11-50-13-removebg-preview.png"
                alt="Godske Byg & Anlæg"
                className="h-16 w-auto object-contain brightness-0 invert"
              />
            </Link>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-white mb-4">
              Navigation
            </h3>
            <ul className="space-y-2.5">
              {navigation.links.filter(link => link.path !== "/ydelser").map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-brand-accent transition-colors text-gray-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-white">
              Kontaktoplysninger
            </h3>
            <ul className="space-y-3.5 text-sm text-gray-300">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-brand-accent shrink-0 mt-0.5" />
                <span>
                  {companyInfo.address}
                  <br />
                  {companyInfo.zipCity}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-brand-accent shrink-0" />
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="hover:text-brand-accent transition-colors whitespace-nowrap"
                >
                  {companyInfo.phoneFormatted}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-brand-accent shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="hover:text-brand-accent transition-colors whitespace-nowrap"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="relative z-10 border-t border-[#3d1b1c] bg-[#3d1b1c] py-6 text-center text-xs text-gray-300">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>© {currentYear} {companyInfo.name}. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-4 text-gray-400 text-[11px]">
            <span>CVR-nr: {companyInfo.cvr}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
